module.exports = __webpack_public_path__ + "img/symbol_3.ba76c919.png";